import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import styles from "../../../../src/content/buses-for-bolivia/styles";
import "../../../../src/content/buses-for-bolivia/bolivia-buses.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  styles,
  React
};